import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgScheduleFill = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	height: 24,
	viewBox: "0 -960 960 960",
	width: 24,
	...props,
	children: /* @__PURE__ */ _jsx("path", { d: "M480-80q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-83 31.5-156T197-763q54-54 127-85.5T480-880q83 0 156 31.5T763-763q54 54 85.5 127T900-480q0 83-31.5 156T763-197q-54 54-127 85.5T480-80Zm132-212 56-56-148-148v-184h-80v216l172 172Z" })
});
export default SvgScheduleFill;
